const RugTablesBlu = Object.freeze({
    CREDIT: 'CREDIT',
    GUARANTEE: 'GUARANTEE',
    CLIENT: 'CLIENT'
})

module.exports = RugTablesBlu
